export const centsToDollarsDisplay = (cents?: number, unsigned: boolean = false): string => {
	if (!cents) return (0).toFixed(2);

	return ((unsigned ? Math.abs(cents) : cents) / 100).toFixed(2);
};

export const displayCentsWithDollarSign = (cents?: number): string => {
	const sign = cents !== undefined && cents < 0 ? "-" : "";

	return `${sign}$${centsToDollarsDisplay(cents, true)}`;
};

/**
 * Trim trailing-zero decimals from any percentage in a string: "10.00%" -> "10%",
 * "10.50%" -> "10.5%". Only touches "<number>%" tokens — currency amounts have no
 * percent sign and keep their two decimals.
 */
export const trimPercentZeros = (text: string): string =>
	text.replace(/(\d+(?:\.\d+)?)%/g, (_, num) => `${parseFloat(num)}%`);

export const formatToDisplayTime = (dateString: string): string => {
	const date = new Date(dateString);

	// Format time in 24-hour format (21:42)
	const hours = date.getHours();
	const minutes = date.getMinutes();
	const timeStr = `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;

	// Format date (26/02/2026)
	const day = date.getDate();
	const month = date.getMonth() + 1; // getMonth() returns 0-11
	const year = date.getFullYear();
	const dateStr = `${day.toString().padStart(2, "0")}/${month.toString().padStart(2, "0")}/${year}`;

	return `${dateStr}  ${timeStr}`;
};
